module.exports = __webpack_public_path__ + "img/twitter-logo.74102875.png";